import styles from "./ErrorState.module.css";

interface ErrorStateProps {
  /** Detalle del error; vacío = solo el título y «Reintentar». */
  message: string;
  onRetry: () => void;
  /** Qué no se ha podido cargar («Los leads no se han podido cargar.»); por defecto, el genérico. */
  title?: string;
}

/** Error de nuestra API: lenguaje llano y `Reintentar` que repite esa petición — panel-interaction-spec.md §2. */
export function ErrorState({ message, onRetry, title = "No se ha podido cargar" }: ErrorStateProps) {
  return (
    <div className={styles.wrap} role="alert">
      <svg className={styles.icon} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
        <path d="M12 8v5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="12" cy="16" r="0.75" fill="currentColor" />
      </svg>
      <p className={styles.title}>{title}</p>
      {message ? <p className={styles.body}>{message}</p> : null}
      <button type="button" className={styles.retry} onClick={onRetry}>
        Reintentar
      </button>
    </div>
  );
}
